import { getBaseUrlParams } from "./getBaseUrlParams";

// Matches compound IDs: {user_id}_{store_db_id} (e.g., 128181759_9595)
// Non-global version for testing single values
const COMPOUND_ID_TEST_RE = /^\d{8,9}_\d+$/;
const COMPOUND_ID_RE = /\b(\d{8,9})_(\d+)\b/g;

/**
 * Parse a compound ID string into client_uid and object_id.
 * "128181759_9595" => { clientUid: "128181759", objectId: "9595" }
 */
const parseCompoundId = (compoundId) => {
  const parts = String(compoundId).split("_");
  return { clientUid: parts[0], objectId: parts[1] };
};

/**
 * Build a client profile href for a given client UID and object ID.
 */
const href = (organizationId, clientUid, shortUrl, objectId) =>
  `/organizations/${organizationId}/client_profiles/${organizationId}?client_uid=${clientUid}${objectId ? `&object_id=${objectId}` : ""}&dashboard_short_url=${shortUrl || ""}`;

/**
 * Replace compound IDs ({user_id}_{store_db_id}) in an HTML string with client profile links.
 * Skips IDs already inside an <a> tag.
 */
const linkifyHtml = (html) => {
  if (!html || typeof html !== "string") return html;
  const { organization_id, short_url } = getBaseUrlParams();
  if (!organization_id) return html;

  // Split on existing <a ...>...</a> tags to avoid double-linking
  const parts = html.split(/(<a\b[^>]*>.*?<\/a>)/gi);
  return parts
    .map((part) => {
      // If this part is an <a> tag, leave it alone
      if (/^<a\b/i.test(part)) return part;
      return part.replace(COMPOUND_ID_RE, (match, userId, storeDbId) => {
        const url = href(organization_id, userId, short_url, storeDbId);
        return `<a href="${url}" target="_client_profile">${userId}</a>`;
      });
    })
    .join("");
};

export const linkifyClientIds = { COMPOUND_ID_TEST_RE, COMPOUND_ID_RE, href, parseCompoundId, linkifyHtml };
